import { useQuery } from "@tanstack/react-query";
import { getItems } from "../../../api/items";
import { SESSION_LEAD_TYPE_FIELDS } from "./leadClientTypes";

// Sessions carrying the client type of the lead that originated them — the source of the child/adult chips
// on session cards. Raw items (not an aggregate) because Directus returns 500 on a relational groupBy over
// lead.client_type; the universes are small (tens to ~100 sessions per card).
export const useSessionsByLeadType = (queryKey: Array<string>, filter: Record<string, unknown>, enabled = true) => {
    const result = useQuery({
        queryKey: ["sessions-lead-type", ...queryKey],
        queryFn: () => getItems("sessions", SESSION_LEAD_TYPE_FIELDS, { filter, pageSize: 2000, sort: "id" }),
        enabled,
        staleTime: 5 * 60 * 1000,
    });
    return result;
};
